import { connect } from 'react-redux';
import { selectUserData } from 'selectors/general';
import { Optimizely } from './Optimizely';
import { setAvailable } from './reducer';

const mapStateToProps = state => {
  const user = selectUserData(state);
  return {
    user,
  };
};

const mapDispatchToProps = {
  setAvailable,
};

export default connect(mapStateToProps, mapDispatchToProps)(Optimizely);
